module.exports = __webpack_public_path__ + "img/link-payon-sm.c50b2328.svg";